<template>
  <div
    v-if="isGroupCell"
    :class="[$style.project_cell, $style.with_background]"
    :style="{ background: groupColor, maxWidth: firstColumnWidth }"
  >
    <svg-sprite
      v-if="cell.column.columnDef.icon"
      :class="$style.icon"
      :name="cell.column.columnDef.icon.name"
      :type="cell.column.columnDef.icon.type"
      :color="cell.column.columnDef.icon.color"
      :size="cell.column.columnDef.icon.size"
      :style="{minWidth: cell.column.columnDef.icon.size + 'px'}"
    />
    <div :class="[$style.value, $style.full_width]">
      {{ textValue }}
    </div>
  </div>
  <div
    v-else
    :class="$style.text_cell"
    :style="{maxWidth: textValueWidth}"
  >
    <div
      :class="{
        [$style.value]: true,
        [$style.full_width]: true,
      }"
    >
      {{ textValue }}
    </div>
  </div>
</template>

<script>
import { ColorCycler } from '../helpers';

export default {
  props: {
    cell: { type: Object, required: true },
    columnsSizes: { type: Object, required: true },
  },
  data() {
    return {};
  },
  computed: {
    isGroupCell() {
      return this.cell.getIsGrouped();
    },
    textValue() {
      return this.cell.column.columnDef.cell ? this.cell.column.columnDef.cell(this.cell.getContext()) : this.cell.getValue();
    },
    groupKey() {
      const cellData = this.cell.row.original[this.cell.column.id];

      return cellData.id;
    },
    groupColor() {
      const cellData = this.cell.row.original[this.cell.column.id];

      return cellData.color;
    },
    textValueWidth() {
      if (this.isGroupCell) {
        return 'fit-content';
      }

      const width = this.columnsSizes[this.cell.column.id];

      return `${parseFloat(width) - 10}px`;
    },
    firstColumnWidth() {
      const firstColumnWidth = Object.values(this.columnsSizes)
        .slice(0, 3)
        .reduce((sum, value) => sum + parseFloat(value), 0);
      const width = firstColumnWidth - 200;

      return `${width}px`;
    },
  },
  methods: {
    getColorForGroup(key) {
      return ColorCycler.getColor(key);
    },
  },
};
</script>

<style module src="./cell.less" lang="less"></style>
